import { api } from '../index';

export const hidden = notificationId => api.post(`/notification/read/${notificationId}`);
